import styles from "./player-notice.module.css";

export const PlayerNotice = "div";
export const PlayerNoticeClassName = styles.playerNotice;

export const PlayerNoticeTitle = "h3";
export const PlayerNoticeTitleClassName = styles.playerNoticeTitle;

export const PlayerNoticeText = "p";
export const PlayerNoticeTextClassName = styles.playerNoticeText;
